import { isNewPostsNotificationDetails } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { NotificationData } from "@/types";

export default function(notification: Notification): NotificationData | false {
  const details = notification.details;
  if (notification.type === NotificationType.NEW_POSTS) {
    return {
      text: $t("{0} just posted something new", [notification.user?.screenName]),
      position: "top",
      timeout: 7000,
      image: {
        user: notification.user,
      },
      onNotificationClick: () =>
        router.push(
          getProfileUrl(notification.userId, {
            feedId: isNewPostsNotificationDetails(details) ? details.postId : undefined,
          })
        ),
    };
  }
  return false;
}
